/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class AttributeMasterDialog extends _Ext.DialogBase<AttributeMasterRow, any> {
        protected getFormKey() { return AttributeMasterForm.formKey; }
        protected getIdProperty() { return AttributeMasterRow.idProperty; }
        protected getLocalTextPrefix() { return AttributeMasterRow.localTextPrefix; }
        protected getNameProperty() { return AttributeMasterRow.nameProperty; }
        protected getService() { return AttributeMasterService.baseUrl; }
        protected getInsertPermission() { return AttributeMasterRow.insertPermission; }
        protected getUpdatePermission() { return AttributeMasterRow.updatePermission; }
        protected getDeletePermission() { return AttributeMasterRow.deletePermission; }
        //protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions) }
        protected useViewMode() { return true; }

        protected form = new AttributeMasterForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();


            q.setTextRightAlign(this.form.MaxPurity);
            q.setTextRightAlign(this.form.MinPurity);
            q.setTextRightAlign(this.form.StdPurity);
            q.setTextRightAlign(this.form.SPGravity);
            q.setTextRightAlign(this.form.PurchaseFormula);
            q.setTextRightAlign(this.form.SalesFormula);
            this.form.AttributeTypeId.changeSelect2(e => {
                this.setFields();

            });

            this.form.AttributeCode.changeSelect2(e => {
                let self = this;
                var id = AttributeMasterRow.getLookup().items.filter(x => x.AttributeTypeId == parseInt(self.form.AttributeTypeId.value)
                    && x.AttributeCode.toUpperCase() == self.form.AttributeCode.value.toUpperCase())[0];
                if (id != undefined) {
                    if (id.AttributeId != null || id.AttributeId > 0) {
                        Q.notifyError("Duplicate Attribute " + self.form.AttributeCode.value);
                        self.form.AttributeCode.value = "";
                        self.form.AttributeCode.element.focus();
                        return;
                    }
                }
                else {
                    self.form.AttributeCode.value = self.form.AttributeCode.value.toUpperCase();
                }
            })
        }

        protected onSaveAndNewButtonClick() {
            this.save(response => {

                let row: AttributeMasterRow = {
                    AttributeTypeId: Q.parseInteger(this.form.AttributeTypeId.value)
                }

                this.loadEntity(row);
            });
        }

        setFields() {
            if (this.form.AttributeTypeId.value == "16" || this.form.AttributeTypeId.value == "17") {
                // Set read only to true for a field

                this.form.MinPurity.getGridField().toggle(true);
                this.form.MinPurity.getGridField().toggle(true);
                this.form.MaxPurity.getGridField().toggle(true);
                this.form.StdPurity.getGridField().toggle(true);
                this.form.SPGravity.getGridField().toggle(true);
            }
            else {
                this.form.MinPurity.getGridField().toggle(false);
                this.form.MaxPurity.getGridField().toggle(false);
                this.form.StdPurity.getGridField().toggle(false);
                this.form.SPGravity.getGridField().toggle(false);

            }
            if (this.form.AttributeTypeId.value == "17") {
                q.showAndSetRequiredField(this.form.Num1);
                q.showAndSetRequiredField(this.form.PurchaseFormula);
                q.showAndSetRequiredField(this.form.SalesFormula);
            }
            else {
                q.hideField(this.form.Num1);
                q.hideField(this.form.PurchaseFormula);
                q.hideField(this.form.SalesFormula);
            }
            if (this.form.AttributeTypeId.value == "13") {
                q.showAndEnableField(this.form.GroupSieveId);
                q.showAndEnableField(this.form.IsParent);
            }
            else {
                q.hideField(this.form.GroupSieveId);
                q.hideField(this.form.IsParent);
            }
        }

        afterLoadEntity() {
            super.afterLoadEntity();
            this.setFields();
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            return btns;
        }
        protected validateBeforeSave() {
            let returnvalue = super.validateBeforeSave();
            let id = AttributeMasterRow.getLookup().items.filter(x => x.AttributeTypeId.toString() == this.form.AttributeTypeId.value.toString()
                && x.AttributeCode.toUpperCase() == this.form.AttributeCode.value.toUpperCase())[0];
            if (id != undefined) {
                if (id.AttributeId != null || id.AttributeId > 0) {
                    Q.notifyError("Duplicate Attribute " + this.form.AttributeCode.value);
                    this.form.AttributeCode.value = "";
                    this.form.AttributeCode.element.focus();
                    return;
                }
            }
            else {
                this.form.AttributeCode.value = this.form.AttributeCode.value.toUpperCase();
            }
            return returnvalue;

        }
        onSaveSuccess(response) {
            Q.reloadLookup('Attribute.Sieve');

        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let id: AttributeMasterRow;
            AttributeMasterService.Retrieve(
                { EntityId: this.form.AttributeId.value },
                response => {
                    if (response.Entity != null)
                        id = response.Entity;
                }, { async: false }
            )
            var refid: CommonAttributesRow;

            switch (id.AttributeTypeId) {
                case 11:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        SuperTypeId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 13:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        SieveId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 15:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StampId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 17:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        KaratId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 18:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        MetalColorId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 19:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        ShapeId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 20:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        QualityId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 21:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneSizeId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 22:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        SettingId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 23:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneColorId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                /*
               case 131:
                   //var refid = CommonAttributesRow.getLookup().items.filter(x => x.StoneColorId == id.AttributeId)[0];
                   
                   OMS.CommonAttributesService.CheckAttributeUsage({
                       Jewel: id.AttributeId
                   }, response => {
                       refid = response.Entity;
                   }, { async: false });
                
                   break;
                   */
                case 291:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneCutId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 292:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StonePolishId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
                case 293:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneSymmetryId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 294:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneFluorescenceId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 295:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneCuletId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });

                    break;
                case 296:
                    OMS.CommonAttributesService.CheckAttributeUsage({
                        StoneGirdleId: id.AttributeId
                    }, response => {
                        refid = response.Entity;
                    }, { async: false });
                    break;
            }
            if (refid != null && refid.Attribute != null) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Attribute is in use, Cannot delete");
                    return;
                }
            }
            else {
                AttributeMasterService.Delete(
                    { EntityId: this.entityId },
                    response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

            Q.reloadLookup(AttributeMasterRow.lookupKey);
        }
    }
}
/*
11	ATT_TYPE	SUPER TYPE
12	ATT_TYPE	COLLECTION
13	ATT_TYPE	SIEVE SIZE
14	ATT_TYPE	BRAND
15	ATT_TYPE	STAMP
16	ATT_TYPE	METAL
17	ATT_TYPE	KARAT
18	ATT_TYPE	METAL COLOR
19	ATT_TYPE	SHAPE
20	ATT_TYPE	QUALITY
21	ATT_TYPE	STONE SIZE
22	ATT_TYPE	SETTING
23	ATT_TYPE	STONE COLOR
24	ATT_TYPE	STONE STATUS
108	ATT_TYPE	LABOUR GROUP
109	ATT_TYPE	CREDIT DAYS
131	ATT_TYPE	JEWELLERY SIZE
291	ATT_TYPE	CUT
292	ATT_TYPE	POLISH
293	ATT_TYPE	SYMMETRY
294	ATT_TYPE	FLUORESCENCE
295	ATT_TYPE	CULET
296	ATT_TYPE	GIRDLE
300	ATT_TYPE	ORDERSTATUS
*/